module.exports = __webpack_public_path__ + "img/fi-rr-signal-alt-1.9962c697.svg";